
import { computed, defineComponent, ref, watch } from "vue";

import missingLtkImage from "../../assets/missing-ltk.svg";

export default defineComponent({
  props: {
    src: {
      type: String,
      required: true,
    },
    errorSrc: {
      type: String,
      default: missingLtkImage,
    },
    loading: {
      type: String,
      default: "lazy",
    },
    maxRetries: {
      type: Number,
      default: 3,
    },
  },
  emits: {},
  setup(props, { attrs }) {
    const currentSrc = ref(props.src);
    const loaded = ref(false);
    const hasImgError = ref(false);
    const retryCount = ref(0);

    // Filter out incompatible props from being bound/overridden to image element
    const imgProps = computed(() => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { src, errorSrc, maxRetries, ...$props } = props;

      return { ...$props, ...attrs };
    });
    const imgSrc = computed(() => {
      return hasImgError.value ? props.errorSrc : currentSrc.value;
    });

    watch(
      () => props.src,
      (newValue) => {
        currentSrc.value = newValue;
        hasImgError.value = false;
        loaded.value = false;
        retryCount.value = 0;
      },
      { immediate: true },
    );

    const onSrcError = () => {
      /**
       * Manually alters the format of the requested image to be a jpeg if a webp was requested.
       * Currently the imagesizer has a bug where it returns a 300 with no hint as to how to resolve,
       * leading to broken images. This is scenario happens with source images that have alpha transparency,
       * and the output format is requested to be webp. This is a hack to resolve ch51476
       */
      const fallbackSrc = currentSrc.value.replace("fm=webp", "fm=jpg");
      if (fallbackSrc !== currentSrc.value) {
        currentSrc.value = fallbackSrc;
        return;
      }

      // When it is discovered why images are having total failues in bulk, this functionality should be removed.
      // This is a hack to resolve ch56852 in the interim to provide a better user experience.
      // Retry loading the image up to the max retries
      if (retryCount.value < props.maxRetries) {
        retryCount.value += 1;
        const img = new Image();

        img.onerror = onSrcError;
        img.src = currentSrc.value;

        return;
      }

      hasImgError.value = true;
    };

    return { imgProps, currentSrc, loaded, hasImgError, retryCount, imgSrc, onSrcError };
  },
});
